import PagesService from "@/api/services/pagesService";
import { CustomPage } from "@/interfaces/Pages/CustomPage.ts";
import { defineStore } from "pinia";

interface CustomPageState {
  pages: Partial<Record<string, CustomPage>>;
  props: Partial<Record<string, any>>;
}

export const useCustomPageStore = defineStore("customPage", {
  state: (): CustomPageState => ({
    pages: {},
    props: {},
  }),

  getters: {
    getProps: (state: CustomPageState) => (url: string) => state.props[url],
    getCustomPage: (state: CustomPageState) => (url: string, lang: string) => state.pages[`${url}_${lang}`] || state.pages[url],
  },

  actions: {
    addProps(url: string, props: Record<string, any>) {
      this.props[url] = props;
    },
    addCustomPage(url: string, page: CustomPage, lang: string) {
      const hash = page.type === "landing" ? `${url}_${lang}` : url;

      if (page && !page.has_password) {
        this.pages[hash] = page;
      }
    },
    async fetchCustomPage(url: string, password: string | null, lang: string): Promise<CustomPage> {
      const page: CustomPage = await PagesService.get(url, password);
      this.addCustomPage(url, page, lang);
      return page;
    },
  },
});
